import React from 'react';
import SubscriptionExpiredPopUp from 'components/common/subscriptionExpiredPopUp';
import Modal from 'components/common/modal/modal';

const ExpiredSubscription: React.FC = () => {
  return (
    <div>
      <Modal
        isOpen
        modalOpen={() => null}
        modalContent={<SubscriptionExpiredPopUp modalClose={() => null} />}
      />
    </div>
  );
};

export default ExpiredSubscription;
